export default __webpack_public_path__ + "static/media/gitHub.3f29d682.svg";